import {combineReducers} from 'redux'
import types from '../../../actions/types'

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_LOAD_LIST_ATTEMPT:
      return true
    case types.CONTACT_LISTS_LOAD_LIST_SUCCESS:
      return false
    case types.CONTACT_LISTS_LOAD_LIST_FAILURE:
      return false
    default:
      return state
  }
}

export const contactListId = (state = null, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return null
    case types.CONTACT_LISTS_LOAD_LIST_ATTEMPT:
      return action.listId
    default:
      return state
  }
}

export default combineReducers({
  isLoading,
  contactListId,
})